const getPageNumberFromHydraString = (str) => {
    // The string is formatted like /search/result/?page=1
    // Extract the part after the ? to get the page number
    const urlParams = new URLSearchParams(str.split("?")[1]);
    const page = urlParams.get('page');
    if (!page) {
        throw new Error("Cannot determine page number from result.");
    }
    return parseInt(page);
};

export default getPageNumberFromHydraString;
